var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

function readyListTracking(){
    var savingRetrieval = window.EDMDataStorage.leadformTracking; //NOTE THAT THIS MATCHES THE KEY IN FTL.
    if(savingRetrieval) {
        savingRetrieval.ads = {
            disable_refresh: true
        };
        eventToolbox.fireAction(savingRetrieval); //pixel gets fired here
    }
}
function fireOpenWidgetTracking(){
    eventToolbox.fireAction({
        'event_type': 'action_start',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name':'lead_submission',
            'subaction_name':'display_lead_form',
            'action_cause': 'page_load',
            'creative_id': 'edm-entry-pricing-lead-form'
        }
    });
}

function fireSuccessfulSubmit(typeStr, blended, count){
    eventToolbox.fireAction({
        'event_type': 'action_completed',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'system',
            'action_name': 'lead_submit_validation',
            'subaction_name': 'processed_submit',
            'action_cause': 'button_click',
            'type':typeStr,
            'isBlended':blended,
            'total':count,
            'creative_id': 'edm-entry-pricing-lead-form'
        }
    });
}

module.exports = {
    fireOpenWidgetTracking:fireOpenWidgetTracking,
    fireSuccessfulSubmit:fireSuccessfulSubmit,
    readyListTracking:readyListTracking

};


//////////////////
// WEBPACK FOOTER
// ./src/creative/pricing-lead-form/lead-form-tracking.js
// module id = 150
// module chunks = 0 1 16 19